export const usersMicroserviceUrl = 'https://telemetry.blinkelectrics.co.ke/users';